import Empty from 'general/components/Empty'
import ProtectedRoute from 'general/components/Routes/ProtectedRoute'
import AppResource from 'general/constants/AppResource'
import Utils from 'general/utils/Utils'
import { useAppSelector } from 'hooks/useRedux'
import { useMemo } from 'react'
import { Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { Route, Routes } from 'react-router-dom'
import ChooseTemplateInvoice from './screens/ChooseTemplateInvoice'
import CreateTemplateInvoice from './screens/CreateTemplateInvoice'
import ListTemplateInvoice from './screens/ListTemplateInvoice'

function TemplateInvoice() {
  // MARK: --- Params ---
  const { t } = useTranslation()
  const userFunction = useAppSelector((state) => state?.function?.userFunctions)
  const listFunction = useAppSelector((state) => state?.function?.listFunctions)

  const [isViewTemplateInvoice] = useMemo(() => {
    return Utils.checkFunction(
      [
        {
          listFunctionCode: 'TEMPLATE_INVOICE_VIEW_LIST',
        },
      ],
      userFunction,
      listFunction,
    )
  }, [userFunction, listFunction])

  return (
    <Routes>
      <Route
        path=""
        element={
          <ProtectedRoute permission={isViewTemplateInvoice}>
            <ListTemplateInvoice />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tao/:templateInvoiceId"
        element={<CreateTemplateInvoice />}
      />
      <Route path="/chon" element={<ChooseTemplateInvoice />} />
      <Route
        path="/sua/:templateInvoiceId"
        element={<CreateTemplateInvoice />}
      />

      <Route
        path="*"
        element={
          <Container fluid className="h-100 d-flex">
            <Row className="justify-content-center align-items-center flex-grow-1">
              <Empty
                text={t('PageNotFound')}
                buttonText={t('Refresh')}
                visible={false}
                imageEmpty={AppResource.icons.icEmptyBox}
              />
            </Row>
          </Container>
        }
      />
    </Routes>
  )
}

export default TemplateInvoice
